module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiNmZmY7b3BhY2l0eTowLjc7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMCwwSDI0VjI0SDBaIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0yMCw0SDRBMiwyLDAsMCwwLDIuMDEsNkwyLDE4YTIuMDA2LDIuMDA2LDAsMCwwLDIsMkgyMGEyLjAwNiwyLjAwNiwwLDAsMCwyLTJWNkEyLjAwNiwyLjAwNiwwLDAsMCwyMCw0Wm0wLDQtOCw1TDQsOFY2bDgsNSw4LTVaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_mail.svg
// module id = xLAB
// module chunks = 97